import { z } from 'zod';

import { ComponentInstanceSchema } from './DiagramComponentInstance.schema';

const DiagramCommunicationSchema = z.object({
    id: z.string(),
    from: ComponentInstanceSchema.shape.id,
    to: ComponentInstanceSchema.shape.id,
    label: z.string().default(''),
    notes: z.string().default(''),
    interface: z.string().nullable().default(null),
    protocol: z.string().nullable().default(null),
});

export { DiagramCommunicationSchema };
